var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChallenge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 17l1.615 11.008 58.799 57.664-10.287 10.75L87.04 102 109 79.052l-5.95-13.901-10.286 10.748-58.781-57.68zM109.494 92L100 101.781l9.504 9.219 9.496-9.781L109.494 92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 17l-1.617 11.008-58.797 57.664 10.286 10.75L41.959 102 20 79.052l5.949-13.901 10.285 10.748 58.782-57.68zM19.504 92L29 101.781 19.494 111 10 101.219 19.504 92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChallenge);
export default __webpack_public_path__ + "static/media/icon-challenge.7106fbf6.svg";
export { ForwardRef as ReactComponent };